exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bread-crumbs-wrapper[data-v-6915e212] {\n  color: #085FCE;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.bread-crumbs-wrapper .bread-crumb[data-v-6915e212] {\n  transition: all 0.2s ease-in-out;\n}\n.bread-crumbs-wrapper .bread-crumb[data-v-6915e212]:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}", ""]);

// exports
